export const allWeekDays = [
  { value: 'mon', label: 'MON' },
  { value: 'tue', label: 'TUE' },
  { value: 'wed', label: 'WED' },
  { value: 'thu', label: 'THU' },
  { value: 'fri', label: 'FRI' },
  { value: 'sat', label: 'SAT' },
  { value: 'sun', label: 'SUN' },
]

export const terrainOptions = [
  { label: 'Flat', value: 'Flat' },
  { label: 'Moderate', value: 'Moderate' },
  { label: 'Steep', value: 'Steep' },
]

export const auxiliary_load_options = [
  { label: 'None', value: 'none' },
  { label: 'Refrigerated truck', value: 'refrigerated_truck' },
  { label: 'Cement mixer', value: 'cement_mixer' },
  { label: 'Parcel delivery', value: 'parcel_delivery' },
  { label: 'Garbage truck', value: 'garbage_truck' },
  { label: 'Street Sweeper', value: 'street_sweeper' },
  { label: 'Hooklift truck', value: 'hooklift_truck' },
]

export const auxiliary_load_option_data = {
  none: {
    kwh_km: 0,
    l_km: 0,
  },
  refrigerated_truck: {
    kwh_km: 0.55,
    l_km: 0.05,
  },
  cement_mixer: {
    kwh_km: 0.99,
    l_km: 0.09,
  },
  parcel_delivery: {
    kwh_km: 0.08,
    l_km: 0.01,
  },
  garbage_truck: {
    kwh_km: 0.14,
    l_km: 0.01,
  },
  street_sweeper: {
    kwh_km: 0.15,
    l_km: 0.01,
  },
  hooklift_truck: {
    kwh_km: 0.41,
    l_km: 0.04,
  },
}
